import React, { useState, useEffect } from "react";
import {
  Container,
  Button,
  Modal,
  Form,
  Spinner,
  Alert,
  Card,
  Row,
  Col,
} from "react-bootstrap";
function Crops({ token, onLogout }) {
  const [period, setPeriod] = useState();
  const speciesOptions = ["Aguacate", "Mango"];
  const varietyOptions = {
    Aguacate: [
      "Aguacate Bacon",
      "Aguacate Cocktail",
      "Aguacate Esther",
      "Aguacate Ettinger",
      "Aguacate Fuerte",
      "Aguacate Gween",
      "Aguacate Hass",
      "Aguacate Lamb Hass",
      "Aguacate Maluma Hass",
      "Aguacate Melón",
      "Aguacate Pinkerton",
      "Aguacate Reed",
      "Aguacate Zutano",
    ],
    Mango: [
      "Mango Ataulfo",
      "Mango Genérico",
      "Mango Haden",
      "Mango Irwin",
      "Mango Keitt",
      "Mango Kensington",
      "Mango Kent",
      "Mango Lippens",
      "Mango Manzanillo",
      "Mango Maya",
      "Mango Osteen",
      "Mango Palmer",
      "Mango Sensation",
      "Mango Tommy Atkins",
    ],
  };
  const [recommendationsData, setRecommendationsData] = useState();
  const [crops, setCrops] = useState([]);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState(null);
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [showAnalysisModal, setShowAnalysisModal] = useState(false);
  const [showRecommendationModal, setShowRecommendationModal] = useState(false);
  const [editingCrop, setEditingCrop] = useState(null);
  const [currentAnalysis, setCurrentAnalysis] = useState(null);
  const [newCrop, setNewCrop] = useState({
    crop_name: "",
    species: "",
    variety: "",
    age: "",
    row_spacing: "",
    tree_spacing: "",
    crop_area: "",
    irrigation_period_1: "",
    irrigation_period_2: "",
    irrigation_period_3: "",
  });
  const fieldLabels = {
    crop_name: "Nombre del Cultivo",
    species: "Especie",
    variety: "Variedad",
    age: "Edad (Años)",
    row_spacing: "Espacio entre filas (m)",
    tree_spacing: "Espacio entre árboles (m)",
    crop_area: "Extensión (m²) ",
    plants_per_area: "Árboles por hectárea",
    irrigation_period_1: "Riego aplicado durante el Periodo 1",
    irrigation_period_2: "Riego aplicado durante el Periodo 2",
    irrigation_period_3: "Riego aplicado durante el Periodo 3",
  };
  const fieldInfo = {
    crop_name:
      "Indicar el nombre con el que se quiere identificar el cultivo. Es posible configurar varios cultivos dentro del mismo usuario",
    species: "Especificar la especie del cultivo",
    variety: "Indicar la variedad específica del cultivo",
    age: "Indicar la edad en años del cultivo a configurar",
    crop_area: "Indicar, en metros cuadrados, la superficie del cultivo",
    row_spacing: "Indicar la distancia, en metros, entre las filas de árboles",
    tree_spacing:
      "Indicar la distancia, en metros, entre los árboles de una fila",
    irrigation_period_1: {
      Aguacate:
        "Indicar el riego semanal aplicado durante el periodo de abonado 1 (desde 1 de Marzo hasta 15 de Junio) por cada árbol (l/árbol/semana)",
      Mango:
        "Indicar el riego semanal aplicado durante el periodo de abonado 1 (desde 1 de Abril hasta 31 de Junio) por cada árbol (l/árbol/semana)",
    },
    irrigation_period_2: {
      Aguacate:
        "Indicar el riego semanal aplicado durante el periodo 2 (desde 15 de Junio hasta 31 de Noviembre) por cada árbol (l/árbol/semana)",
      Mango:
        "Indicar el riego semanal aplicado durante el periodo 2 (desde 1 de Julio hasta 31 de Agosto) por cada árbol (l/árbol/semana)",
    },
    irrigation_period_3: {
      Aguacate:
        "Indicar el riego semanal aplicado durante el periodo 3 (desde el 1 de Diciembre al 31 de Diciembre) por cada árbol (l/árbol/semana)",
      Mango: "",
    },
  };

  useEffect(() => {
    const fetchCrops = async () => {
      try {
        const response = await fetch(
          "https://axarquiasostenibleapp.com/api/api/crops",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Error al obtener los cultivos");
        }
        const data = await response.json();
        setCrops(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCrops();
   // getPeriod();
  }, [token]);
  const getPeriod = (species) => {
    const today = new Date();
    const month = today.getMonth() + 1; // getMonth() devuelve de 0 a 11
    const day = today.getDate();
    let period;

    if (species === "Aguacate"){
    if ((month >= 2 && month <= 5) || (month === 6 && day <= 15)) {
      period = 1;
    } else if ((month === 6 && day > 15) || (month >= 7 && month <= 11)) {
      period = 2;
    } else if (month === 12) {
      period = 3;
    } else {
      period = 0; // Indica fuera de los periodos de riego
    }
  }
  else if (species === "Mango"){
    if (month >= 4 && month <= 6) {
      period = 1;
    } else if  (month >= 7 && month <= 8) {
      period = 2;
    } else {
      period = 0; // Indica fuera de los periodos de riego
    }
  }

    setPeriod(period);
   // setPeriod(0);
    return period;
  };
  const handleEdit = (crop) => {
    setEditingCrop(crop);
    setShowEditModal(true);
  };
  const handleViewAnalysis = async (cropId) => {
    try {
      const response = await fetch(
        `https://axarquiasostenibleapp.com/api/api/combined_water_analysis/by_crop/${cropId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Error al obtener el análisis de agua");
      }
      const analysis = await response.json();

      const order = [
        "Nitrogeno_total",
        "Amonio_NH4",
        "Nitrato_NO3",
        "Fosforo",
        "Potasio", // NPK
        "Fosforo_ajustado",
        "Potasio_ajustado", // Otros
        "Calcio",
        "Calcio_ajustado", // Ca
        "Magnesio",
        "Magnesio_ajustado", // Mg
        "Hierro", // Fe
        "Zinc", // Zn
        "Cobre", // Cu
        "Manganeso", // Mn
        "Boro", // B
        "crop_id",
        "id",
      ];

      // Reorganizar el objeto en el nuevo orden
      const reorderedObject = order.reduce((acc, key) => {
        if (analysis.hasOwnProperty(key)) {
          acc[key] = analysis[key];
        }
        return acc;
      }, {});
      setCurrentAnalysis(reorderedObject);
      setShowAnalysisModal(true);
    } catch (err) {
      setError(err.message);
    }
  };
  const handleUpdateAnalysis = async (cropId, updatedData) => {
    const isConfirmed = window.confirm(
      "La edición de estos parámetros puede modificar la recomendación de fertirriego. ¿Desea continuar?"
    );

    if (isConfirmed) {
      try {
        const response = await fetch(
          `https://axarquiasostenibleapp.com/api/api/combined_water_analysis/by_crop/${cropId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(updatedData),
          }
        );
        if (!response.ok) {
          throw new Error("Error al actualizar el análisis de agua");
        }
        const updatedAnalysis = await response.json();
        setCurrentAnalysis(updatedAnalysis);
        setSuccessMessage("Análisis de agua actualizado correctamente.");
      } catch (err) {
        setError(err.message);
      }
    } else {
      console.log("La operación fue cancelada.");
    }
  };
  const handleSaveEdit = async () => {
    const isConfirmed = window.confirm(
      "La edición de estos parámetros puede modificar la recomendación de fertirriego. ¿Desea continuar?"
    );

    if (isConfirmed) {
      try {
        const response = await fetch(
          `https://axarquiasostenibleapp.com/api/api/crops/${editingCrop.id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(editingCrop),
          }
        );
        if (!response.ok) {
          throw new Error("Error al actualizar el cultivo");
        }
        const updatedCrop = await response.json();
        setCrops((prevCrops) =>
          prevCrops.map((crop) =>
            crop.id === updatedCrop.id ? updatedCrop : crop
          )
        );
        setSuccessMessage("Cultivo actualizado correctamente.");
        setShowEditModal(false);
      } catch (err) {
        setError(err.message);
      }
    } else {
      console.log("La operación fue cancelada.");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de que deseas eliminar este cultivo?")) {
      try {
        const response = await fetch(
          `https://axarquiasostenibleapp.com/api/api/crops/${id}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Error al eliminar el cultivo");
        }
        setCrops((prevCrops) => prevCrops.filter((crop) => crop.id !== id));
        setSuccessMessage("Cultivo eliminado correctamente.");
      } catch (err) {
        setError(err.message);
      }
    }
  };
  const handleInputChange = (e) => {
    const regex = /^\d*(\.\d{0,2})?$/;
    const { name, value } = e.target;
    if (
      name != "crop_name" &&
      name != "species" &&
      name != "variety" &&
      name != "plants_per_area" &&
      regex.test(value)
    ) {
      setEditingCrop((prevData) => ({ ...prevData, [name]: value }));
      setErrors({ ...errors, [name]: "" }); // Limpia el error si el formato es correcto
    } else if (name == "crop_name" || name == "species" || name == "variety") {
      setEditingCrop((prevData) => ({ ...prevData, [name]: value }));
      setErrors({ ...errors, [name]: "" }); // Limpia el error si el formato es correcto
    } else {
      setErrors({ ...errors, [name]: "El formato debe ser 0 o 0.00" }); // Muestra el error si el formato es incorrecto
    }
    if (name === "species" && value === "Mango") {
      setEditingCrop((prevData) => ({
        ...prevData,
        ["irrigation_period_3"]: 0,
      }));
    }
  };

  const handleNewCropChange = (e) => {
    const regex = /^\d*(\.\d{0,2})?$/;
    const { name, value } = e.target;
    if (
      name != "crop_name" &&
      name != "species" &&
      name != "variety" &&
      regex.test(value)
    ) {
      setNewCrop((prevData) => ({ ...prevData, [name]: value }));
      setErrors({ ...errors, [name]: "" }); // Limpia el error si el formato es correcto
    } else if (name == "crop_name" || name == "species" || name == "variety") {
      setNewCrop((prevData) => ({ ...prevData, [name]: value }));
      setErrors({ ...errors, [name]: "" }); // Limpia el error si el formato es correcto
    } else {
      setErrors({ ...errors, [name]: "El formato debe ser 0 o 0.00" }); // Muestra el error si el formato es incorrecto
    }
    if (name == "species" && value == "Mango") {
      setNewCrop((prevData) => ({ ...prevData, ["irrigation_period_3"]: 0 }));
    }
  };

  const handleCreateCrop = async () => {
    try {
      const cropResponse = await fetch(
        "https://axarquiasostenibleapp.com/api/api/crops",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(newCrop),
        }
      );
      if (!cropResponse.ok) {
        throw new Error("Error al crear el cultivo");
      }
      const createdCrop = await cropResponse.json();
      setCrops((prevCrops) => [...prevCrops, createdCrop]);
      setSuccessMessage("Cultivo y análisis de agua creados correctamente.");
      setShowCreateModal(false);
      setNewCrop({
        crop_name: "",
        species: "",
        variety: "",
        age: "",
        row_spacing: "",
        tree_spacing: "",
        crop_area: "",
        irrigation_period_1: "",
        irrigation_period_2: "",
        irrigation_period_3: "",
      });
    } catch (err) {
      setError(err.message);
    }
  };
  const handleShowRecommendations = async (
    // cropId,
    // irrigationPeriod,
    // species
    crop
  ) => {
    let species= crop.species
    let period = getPeriod(species)
    let cropId= crop.id
    let irrigationPeriod= crop[`irrigation_period_${period}`]
    let endpoint = crop.species === "Mango" ? "_mango" : "";
    try {
      const [fertilizersRes, nutrientsRes, waterAnalysisRes] =
        await Promise.all([
          fetch(
            `https://axarquiasostenibleapp.com/api/api/fertilizers${endpoint}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          ),
          fetch(
            `https://axarquiasostenibleapp.com/api/api/nutrients${endpoint}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          ),
          fetch(
            `https://axarquiasostenibleapp.com/api/api/combined_water_analysis/by_crop/${cropId}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        ]);

      if (!fertilizersRes.ok || !nutrientsRes.ok || !waterAnalysisRes.ok) {
        throw new Error("Error al obtener los datos de los endpoints");
      }

      const [fertilizers, nutrients, waterAnalysis] = await Promise.all([
        fertilizersRes.json(),
        nutrientsRes.json(),
        waterAnalysisRes.json(),
      ]);
      //Recomendaciones Aguacate

      if (species === "Aguacate") {
        const nitrogenoNutrientsValue = nutrients.find(
          (item) => item.period === period
        )?.Nitrogeno;
        const nitrogeno_ajustado = waterAnalysis.Nitrogeno_total;
        const nitrogenoFertilizer = fertilizers.find(
          (item) => item.fertilizer === "NITRATO AMÓNICO"
        )?.[`period_${period}`];

        const sulfatoNutrientsValue = nutrients.find(
          (item) => item.period === period
        )?.Nitrogeno;
        const sulfatoFertilizer = fertilizers.find(
          (item) => item.fertilizer === "SULFATO AMÓNICO"
        )?.[`period_${period}`];

        const hierroNutrientsValue = nutrients.find(
          (item) => item.period === period
        )?.Hierro;
        const hierro_ajustado = waterAnalysis.Hierro;
        const hierroFertilizer = fertilizers.find(
          (item) => item.fertilizer === "QUELATO DE HIERRO"
        )?.[`period_${period}`];

        const boroNutrientsValue = nutrients.find(
          (item) => item.period === period
        )?.Boro;
        const boro_ajustado = waterAnalysis.Boro;
        const boroFertilizer = fertilizers.find(
          (item) => item.fertilizer === "ÁCIDO BORICO"
        )?.[`period_${period}`];

        const calcioNutrientsValue = nutrients.find(
          (item) => item.period === period
        )?.Calcio;
        const calcio_ajustado = waterAnalysis.Calcio_ajustado;
        const calcioFertilizer = fertilizers.find(
          (item) => item.fertilizer === "NITRATO CALCICO"
        )?.[`period_${period}`];

        const potasioNutrientsValue = nutrients.find(
          (item) => item.period === period
        )?.Potasio;
        const potasio_ajustado = waterAnalysis.Potasio_ajustado;
        const potasioFertilizer = fertilizers.find(
          (item) => item.fertilizer === "SULFATO POTÁSICO"
        )?.[`period_${period}`];

        let nit_recommendation =
          nitrogenoFertilizer != null
            ? ((nitrogenoNutrientsValue -
                nitrogeno_ajustado * 0.001 * irrigationPeriod) *
                100) /
              nitrogenoFertilizer
            : 0;
        const sul_recommendation =
          sulfatoFertilizer != null
            ? ((sulfatoNutrientsValue -
                nitrogeno_ajustado * 0.001 * irrigationPeriod) *
                100) /
              sulfatoFertilizer
            : 0;
        const boro_recommendation =
          boroFertilizer != null
            ? boroNutrientsValue - boro_ajustado * 0.001 * irrigationPeriod
            : 0;
        const hierro_recommendation =
          hierroFertilizer != null
            ? hierroNutrientsValue - hierro_ajustado * 0.001 * irrigationPeriod
            : 0;
        const calcio_recommendation =
          calcioFertilizer != null
            ? ((calcioNutrientsValue -
                calcio_ajustado * 0.001 * irrigationPeriod) *
                100) /
              calcioFertilizer
            : 0;

        const potasio_recommendation =
          potasioFertilizer != null
            ? ((potasioNutrientsValue -
                potasio_ajustado * 0.001 * irrigationPeriod) *
                100) /
              potasioFertilizer
            : 0;

        // console.log(((potasioNutrientsValue - potasio_ajustado * 0.001 * irrigationPeriod) * 100) /potasioFertilizer);
        // console.log(((potasioNutrientsValue - potasio_ajustado * 0.001 * 100) * 100) /potasioFertilizer);
        // console.log(potasio_ajustado)

        //Lógica para ajustar el aporte de NH4NO3 si hay aporte de Nitrato cálcico

        if (calcio_recommendation > 0) {
          let n_addedwithcalcium = calcio_recommendation * 0.16;
          let nit_in_nitamonico_recommendation_grams =
            nit_recommendation * 0.345;
          let nit_to_add =
            nit_in_nitamonico_recommendation_grams - n_addedwithcalcium;
          let nh4no3_to_add = (nit_to_add * 100) / 34.5;
          nit_recommendation = nh4no3_to_add;
        }

        const recommendations = {
          fertilizers: {
            "Nitrato Amónico": {
              name: "Nitrato amónico",
              //formulation: "NH₄NO₃",
              //formulation: "NH₄NO₃",
              formulation: "(34,5-0-0)",
              recommendation: nit_recommendation,
            },
            "Sulfato Amónico": {
              name: "Sulfato amónico",
              //formulation: "(NH₄)₂SO₄",
              formulation: "(21-0-0)",
              recommendation: sul_recommendation,
            },

            "Ácido Bórico": {
              name: "Ácido bórico",
              // formulation: "H₃BO₃",
              formulation: "(17,50%)",
              recommendation: boro_recommendation,
            },
            "Quelato de Hierro": {
              name: "Quelato de hierro",
              // formulation: "Fe",
              formulation: "(6%)",
              recommendation: hierro_recommendation,
            },
            "Nitrato Cálcico": {
              name: "Nitrato cálcico",
              // formulation: "Ca(NO₃)₂",
              formulation: "(16-0-0 + 26,5 Ca)",
              recommendation: calcio_recommendation,
            },
            "Sulfato Potásico": {
              name: "Sulfato potásico",
              // formulation: "K₂SO₄",
              formulation: "(0-0-51 + 16 S)",
              recommendation: potasio_recommendation,
            },
          },
        };

        setRecommendationsData(recommendations);
        setShowRecommendationModal(true);
      } else if (species === "Mango") {
        //Recomendaciones Mango

        const hierroNutrientsValue = nutrients.find(
          (item) => item.period === period
        )?.Hierro;
        const hierro_ajustado = waterAnalysis.Hierro;
        const hierroFertilizer = fertilizers.find(
          (item) => item.fertilizer === "Quelato de hierro"
        )?.[`period_${period}`];

        const hierro_recommendation =
          ((hierroNutrientsValue - hierro_ajustado * 0.001 * irrigationPeriod) *
            100) /
          hierroFertilizer;

        const potasioNutrientsValue = nutrients.find(
          (item) => item.period === period
        )?.Potasio;
        const potasio_ajustado = waterAnalysis.Potasio_ajustado;
        const potasioFertilizer = fertilizers.find(
          (item) => item.fertilizer === "Sulfato potásico"
        )?.[`period_${period}`];

        const potasio_recommendation =
          ((potasioNutrientsValue -
            potasio_ajustado * 0.001 * irrigationPeriod) *
            100) /
          potasioFertilizer;

        const calcioNutrientsValue = nutrients.find(
          (item) => item.period === period
        )?.Calcio;
        const calcio_ajustado = waterAnalysis.Calcio_ajustado;
        const calcioFertilizer = fertilizers.find(
          (item) => item.fertilizer === "Óxido de calcio"
        )?.[`period_${period}`];

        const calcio_recommendation =
          ((calcioNutrientsValue - calcio_ajustado * 0.001 * irrigationPeriod) *
            100) /
          calcioFertilizer;

        const recommendations = {
          fertilizers: {
            "Sulfato Potásico": {
              name: "Sulfato potásico",
              // formulation: " K₂SO₄",
              formulation: "(0-0-50)",
              recommendation: potasio_recommendation,
            },

            "Óxido de Calcio": {
              name: "Óxido de calcio",
              // formulation: "CaO",
              formulation: "(Calcio al 15%",
              recommendation: calcio_recommendation,
            },
            "Quelato de Hierro": {
              name: "Quelato de hierro",
              // formulation: "Fe",
              formulation: "(HIerro al 6%)",
              recommendation: hierro_recommendation,
            },
          },
        };
        setRecommendationsData(recommendations);
        setShowRecommendationModal(true);
      }
    } catch (err) {
      setError(err.message);
    }
  };
  const handleAnalysisInputValidation = (key, value) => {
    const regex = /^\d*(\.\d{0,2})?$/; // Permite números con hasta dos decimales

    if (value === "" || regex.test(value)) {
      setCurrentAnalysis({
        ...currentAnalysis,
        [key]: value,
      });
      setErrors({ ...errors, [key]: "" }); // Limpia el error si el formato es correcto
    } else {
      setErrors({ ...errors, [key]: "El formato debe ser 0.00" }); // Muestra el error si el formato es incorrecto
    }
  };

  const validateUpdateAnalysisForm = () => {
    for (const key in currentAnalysis) {
      if (
        key !== "id" &&
        key !== "crop_id" &&
        key !== "Nitrogeno_total" &&
        key !== "Fosforo_ajustado" &&
        key !== "Potasio_ajustado" &&
        key !== "Calcio_ajustado" &&
        key !== "Magnesio_ajustado"
      ) {
        if (!currentAnalysis[key]) {
          return false; // Si algún campo está vacío, retorna false
        }
      }
    }
    return true; // Todos los campos están llenos
  };
  const validateCreateCropForm = () => {
    if (newCrop.species === "Mango") {
      for (const key in newCrop) {
        if (key != "irrigation_period_3" && !newCrop[key]) {
          return false; // Si algún campo está vacío, retorna false
        }
      }
    } else {
      for (const key in newCrop) {
        if (!newCrop[key]) {
          return false; // Si algún campo está vacío, retorna false
        }
      }
    }
    return true; // Todos los campos están llenos
  };

  const validateEditCropForm = () => {
    if (editingCrop && editingCrop.species === "Mango") {
      for (const key in editingCrop) {
        if (key != "irrigation_period_3" && !editingCrop[key]) {
          return false; // Si algún campo está vacío, retorna false
        }
      }
    } else {
      for (const key in editingCrop) {
        if (!editingCrop[key]) {
          return false; // Si algún campo está vacío, retorna false
        }
      }
    }
    return true; // Todos los campos están llenos
  };

  if (loading) {
    return <Spinner animation="border" />;
  }
  if (error) {
    return <Alert variant="danger">Error: {error}</Alert>;
  }
  return (
    <div className="d-flex flex-column min-vh-100 bg-custom">
      <div className="mt-0 text-center ">
        <img src="/images/as_logo.png" alt="Logo" className="mt-5 mb-3" />
      </div>
      <div className="text-center mt-0 mb-2">
        <p style={{ color: "#009b3d" }}>
          Herramienta para un fertirriego óptimo
          <br></br>
          <i
            onClick={() => setShowInfoModal(true)}
            style={{ cursor: "pointer", color: "#009b3d" }}
            class="bi bi-info-circle-fill fs-3 p-2"
          ></i>
          <i
            onClick={() => setShowCreateModal(true)}
            style={{ cursor: "pointer", color: "#009b3d" }}
            class="bi bi-plus-circle-fill fs-3 p-2"
          ></i>
          <i
            onClick={() => setShowUserModal(true)}
            style={{ cursor: "pointer", color: "#009b3d" }}
            class="bi bi-person-circle fs-3 p-2"
          ></i>
          <i
            onClick={() => setShowHelpModal(true)}
            style={{ cursor: "pointer", color: "#009b3d" }}
            class="bi bi-question-circle-fill fs-3 p-2"
          ></i>
        </p>
      </div>
      <Container className="flex-grow-1">
        <div className="crops-container">
          <Row>
            {crops.map((crop) => (
              <Col key={crop.id} sm={12} md={12} lg={12} className="mb-2">
                <Card className="h-100 card-custom">
                  <Card.Body>
                    <Card.Title>
                      <strong> {crop.crop_name}</strong> ({crop.species} ,{" "}
                      {crop.variety})
                    </Card.Title>
                    <Card.Text>
                      Extensión:
                      <strong>
                        {" "}
                        {crop.crop_area} m<sup>2</sup>
                      </strong>
                      <br></br>Árboles por hectárea:
                      <strong> {crop.plants_per_area.toFixed(0)}</strong>
                    </Card.Text>
                    <div className="d-flex">
                      <Button
                        size="sm"
                        className="me-2 btn-card-primary-custom"
                        onClick={() => handleEdit(crop)}
                      >
                        Editar finca
                      </Button>
                      <Button
                        size="sm"
                        className="me-2 btn-card-primary-custom"
                        onClick={() => handleViewAnalysis(crop.id)}
                      >
                        Análisis de agua
                      </Button>
                      {/* {period ? ( */}
                        <Button
                          size="sm"
                          className="me-2 btn-card-primary-custom"
                          onClick={() =>
                            handleShowRecommendations(
                              //crop.id,
                              //crop[`irrigation_period_${period}`],
                             // crop.species,
                              crop
                            )
                          }
                        >
                          Recomendación de fertirriego
                        </Button>
                      {/* ) : (
                        ""
                      )} */}
                      <Button
                        size="sm"
                        className="me-2 btn-danger-custom"
                        onClick={() => handleDelete(crop.id)}
                      >
                        Eliminar
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
        {successMessage && (
          <Alert className="mt-2 message-custom">{successMessage}</Alert>
        )}
        <Row>
          <Col sm={6} md={6} lg={6}>
            <Button
              className="mt-0 mb-2 w-100 btn-primary-custom"
              onClick={() => setShowCreateModal(true)}
            >
              Nuevo
            </Button>
          </Col>
          <Col sm={6} md={6} lg={6}>
            <Button
              className="w-100 btn-primary-custom mb-4"
              onClick={onLogout}
            >
              Salir
            </Button>
          </Col>
        </Row>
      </Container>
      {/* Modal para crear cultivo */}
      <Modal
        show={showCreateModal}
        size="lg"
        onHide={() => setShowCreateModal(false)}
      >
        <Modal.Header closeButton className="bg-card-custom">
          <Modal.Title>Crear Nuevo Cultivo</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-card-custom-image">
          <Form>
            {/* Selector de especie */}
            <Form.Group>
              <Form.Label className="mt-2 mb-1">Especie</Form.Label>
              <br />
              <small style={{ color: "gray" }}>Indica una especie</small>
              <Form.Control
                as="select"
                name="species"
                value={newCrop.species}
                onChange={handleNewCropChange}
                required
              >
                <option value="">Seleccione una especie</option>
                {speciesOptions.map((species) => (
                  <option key={species} value={species}>
                    {species}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            {/* Selector de variedad */}
            {newCrop.species && (
              <Form.Group>
                <Form.Label className="mt-2">Variedad</Form.Label>
                <br />
                <small style={{ color: "gray" }}>
                  Indica la variedad específica del cultivo
                </small>
                <Form.Control
                  as="select"
                  name="variety"
                  value={newCrop.variety}
                  onChange={handleNewCropChange}
                  required
                >
                  <option value="">Seleccione una variedad</option>
                  {varietyOptions[newCrop.species]?.map((variety) => (
                    <option key={variety} value={variety}>
                      {variety}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            )}

            {/* Renderizado dinámico de otros campos */}
            {Object.keys(newCrop).map((key) => {
              if (
                ![
                  "species",
                  "variety",
                  "irrigation_period_1",
                  "irrigation_period_2",
                  "irrigation_period_3",
                ].includes(key)
              ) {
                return (
                  <Form.Group controlId={key} key={key}>
                    <Form.Label className="mt-2">
                      {fieldLabels[key] || key}
                    </Form.Label>
                    <br />
                    <small style={{ color: "gray" }}>{fieldInfo[key]}</small>
                    <Form.Control
                      type={
                        typeof newCrop[key] === "number" ? "number" : "text"
                      }
                      name={key}
                      value={newCrop[key] || ""}
                      onChange={handleNewCropChange}
                      required
                    />
                    {errors && (
                      <small style={{ color: "red" }}>{errors[key]}</small>
                    )}
                  </Form.Group>
                );
              }
              return null;
            })}

            {/* Campos de periodos de riego dependiendo de la especie */}
            {newCrop.species && (
              <>
                {/* Irrigation Period 1 */}
                <Form.Group>
                  <Form.Label className="mt-2">
                    {fieldLabels["irrigation_period_1"]}
                  </Form.Label>
                  <br />
                  <small style={{ color: "gray" }}>
                    {fieldInfo["irrigation_period_1"][newCrop.species]}
                  </small>
                  <Form.Control
                    name="irrigation_period_1"
                    value={newCrop.irrigation_period_1 || ""}
                    onChange={handleNewCropChange}
                    required
                  />
                  {errors && (
                    <small style={{ color: "red" }}>
                      {errors["irrigation_period_1"]}
                    </small>
                  )}
                </Form.Group>

                {/* Irrigation Period 2 */}
                <Form.Group>
                  <Form.Label className="mt-2">
                    {fieldLabels["irrigation_period_2"]}
                  </Form.Label>
                  <br />
                  <small style={{ color: "gray" }}>
                    {fieldInfo["irrigation_period_2"][newCrop.species]}
                  </small>
                  <Form.Control
                    name="irrigation_period_2"
                    value={newCrop.irrigation_period_2 || ""}
                    onChange={handleNewCropChange}
                    required
                  />
                  {errors && (
                    <small style={{ color: "red" }}>
                      {errors["irrigation_period_2"]}
                    </small>
                  )}
                </Form.Group>

                {/* Irrigation Period 3 - Habilitado solo para Aguacate */}
                {newCrop.species === "Aguacate" ? (
                  <Form.Group>
                    <Form.Label className="mt-2">
                      {fieldLabels["irrigation_period_3"]}
                    </Form.Label>
                    <br />
                    <small style={{ color: "gray" }}>
                      {fieldInfo["irrigation_period_3"][newCrop.species]}
                    </small>
                    <Form.Control
                      name="irrigation_period_3"
                      value={newCrop.irrigation_period_3 || ""}
                      onChange={handleNewCropChange}
                      required
                    />
                    {errors && (
                      <small style={{ color: "red" }}>
                        {errors["irrigation_period_3"]}
                      </small>
                    )}
                  </Form.Group>
                ) : (
                  ""
                )}
              </>
            )}
          </Form>

          {/* Mensaje de validación */}
          {!validateCreateCropForm() && (
            <p className="mt-4 text-center" style={{ color: "red" }}>
              Rellena todos los campos para poder enviar los datos
            </p>
          )}
        </Modal.Body>
        <Modal.Footer className="bg-card-custom">
          <Button
            className="w-100 btn-primary-custom"
            onClick={handleCreateCrop}
            disabled={!validateCreateCropForm()}
          >
            Crear
          </Button>
          <Button
            className="w-100 btn-danger-custom"
            onClick={() => setShowCreateModal(false)}
          >
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal para editar cultivo */}
      <Modal
        size="lg"
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
      >
        <Modal.Header closeButton className="bg-card-custom">
          <Modal.Title>Editar Cultivo</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-card-custom-image">
          <Form>
            {editingCrop && speciesOptions ? (
              <Form.Group>
                <Form.Label className="mt-2 mb-1">Especie</Form.Label>
                <br></br>
                <small style={{ color: "gray" }}>Indica una especie</small>
                <Form.Control
                  as="select"
                  name="species"
                  value={editingCrop.species}
                  onChange={handleInputChange}
                >
                  <option value="">Seleccione una especie</option>
                  {speciesOptions.map((species) => (
                    <option key={species} value={species}>
                      {species}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            ) : (
              ""
            )}
            {editingCrop && editingCrop.species ? (
              <Form.Group>
                <Form.Label className="mt-2 mb-1">Variedad</Form.Label>
                <br></br>
                <small style={{ color: "gray" }}>
                  Indica la variedad específica del cultivo
                </small>
                <Form.Control
                  as="select"
                  name="variety"
                  value={editingCrop.variety}
                  onChange={handleInputChange}
                >
                  <option value={editingCrop.variety}>
                    {editingCrop.variety}
                  </option>
                  {varietyOptions[editingCrop.species].map((variety) => (
                    <option key={variety[editingCrop.species]} value={variety}>
                      {variety}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            ) : (
              ""
            )}
            {editingCrop &&
              Object.keys(editingCrop)
                .filter(
                  (key) =>
                    key !== "id" &&
                    key !== "user_id" &&
                    key != "species" &&
                    key != "variety" &&
                    key != "irrigation_period_1" &&
                    key != "irrigation_period_2" &&
                    key != "irrigation_period_3"
                ) // Filtra los campos no deseados
                .map((key) => (
                  <Form.Group controlId={key} key={key}>
                    {/* Usar traducción amigable */}
                    <Form.Label className="mt-2 mb-1">
                      {fieldLabels[key] || key}
                    </Form.Label>
                    <br></br>
                    <small style={{ color: "gray" }}>{fieldInfo[key]}</small>
                    <Form.Control
                      type={
                        typeof editingCrop[key] === "number" ? "number" : "text"
                      }
                      name={key}
                      value={editingCrop[key] || ""}
                      onChange={handleInputChange}
                      disabled={key === "plants_per_area"}
                    />
                    {errors && (
                      <small style={{ color: "red" }}>{errors[key]}</small>
                    )}
                  </Form.Group>
                ))}

            {editingCrop ? (
              <>
                {/* Irrigation Period 1 */}
                <Form.Group>
                  <Form.Label className="mt-2">
                    {fieldLabels["irrigation_period_1"]}
                  </Form.Label>
                  <br />
                  <small style={{ color: "gray" }}>
                    {fieldInfo["irrigation_period_1"][editingCrop.species]}
                  </small>
                  <Form.Control
                    name="irrigation_period_1"
                    value={editingCrop.irrigation_period_1 || ""}
                    onChange={handleInputChange}
                    required
                  />
                  {errors && (
                    <small style={{ color: "red" }}>
                      {errors["irrigation_period_1"]}
                    </small>
                  )}
                </Form.Group>
              </>
            ) : (
              ""
            )}
            {editingCrop ? (
              <>
                {/* Irrigation Period 2 */}
                <Form.Group>
                  <Form.Label className="mt-2">
                    {fieldLabels["irrigation_period_2"]}
                  </Form.Label>
                  <br />
                  <small style={{ color: "gray" }}>
                    {fieldInfo["irrigation_period_2"][editingCrop.species]}
                  </small>
                  <Form.Control
                    name="irrigation_period_2"
                    value={editingCrop.irrigation_period_2 || ""}
                    onChange={handleInputChange}
                    required
                  />
                  {errors && (
                    <small style={{ color: "red" }}>
                      {errors["irrigation_period_2"]}
                    </small>
                  )}
                </Form.Group>
              </>
            ) : (
              ""
            )}

            {/* Irrigation Period 3 - Habilitado solo para Aguacate */}
            {editingCrop && editingCrop.species === "Aguacate" ? (
              <Form.Group>
                <Form.Label className="mt-2">
                  {fieldLabels["irrigation_period_3"]}
                </Form.Label>
                <br />
                <small style={{ color: "gray" }}>
                  {fieldInfo["irrigation_period_3"][editingCrop.species]}
                </small>
                <Form.Control
                  name="irrigation_period_3"
                  value={editingCrop.irrigation_period_3 || ""}
                  onChange={handleInputChange}
                  required
                />
                {errors && (
                  <small style={{ color: "red" }}>
                    {errors["irrigation_period_3"]}
                  </small>
                )}
              </Form.Group>
            ) : (
              ""
            )}
          </Form>
          {!validateEditCropForm() ? (
            <p className="mt-4 text-center" style={{ color: "red" }}>
              Rellena todos los campos para poder enviar los datos
            </p>
          ) : (
            ""
          )}
        </Modal.Body>
        <Modal.Footer className="bg-card-custom">
          <Button
            className="w-100 btn-primary-custom"
            onClick={handleSaveEdit}
            disabled={!validateEditCropForm()}
          >
            Guardar
          </Button>
          <Button
            className="w-100 btn-danger-custom"
            onClick={() => setShowEditModal(false)}
          >
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal para ver/editar análisis de agua */}
      <Modal
        show={showAnalysisModal}
        size="lg"
        onHide={() => setShowAnalysisModal(false)}
      >
        <Modal.Header closeButton className="bg-card-custom">
          <div className="d-flex align-items-center justify-content-center">
            <Modal.Title>Análisis de Agua</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body className="bg-card-custom-image">
          <div className="mb-2">
            <small className="text-center mt-2 mb-2">
              Introduzca los resultados de su analítica de agua de riego para
              personalizar la recomendación de fertilización en sus cultivos.
              Puede modificar estos datos cada vez que cuente con una analítica
              nueva de agua, el sistema recalculará las cantidades de
              fertilizantes.
            </small>
          </div>
          {currentAnalysis ? (
            <Form>
              {Object.keys(currentAnalysis)
                // Filtra los campos no deseados
                .filter(
                  (key) =>
                    key !== "id" &&
                    key !== "crop_id" &&
                    key !== "Nitrogeno_total" &&
                    key !== "Fosforo_ajustado" &&
                    key !== "Potasio_ajustado" &&
                    key !== "Calcio_ajustado" &&
                    key !== "Magnesio_ajustado"
                )
                .map((key) => (
                  <Form.Group controlId={key} key={key}>
                    <Form.Label>
                      {key}{" "}
                      {key != "Hierro" &&
                      key != "Cobre" &&
                      key != "Manganeso" &&
                      key != "Boro"
                        ? "mcg/ml"
                        : "mg/l"}{" "}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={currentAnalysis[key] || ""}
                      // onChange={(e) =>
                      //   setCurrentAnalysis({
                      //     ...currentAnalysis,
                      //     [key]: e.target.value,
                      //   })
                      // }
                      onChange={(e) =>
                        handleAnalysisInputValidation(key, e.target.value)
                      }
                      placeholder="0.00"
                    />
                    {errors && (
                      <small style={{ color: "red" }}>{errors[key]}</small>
                    )}
                  </Form.Group>
                ))}
            </Form>
          ) : (
            <p>Cargando análisis...</p>
          )}
          {!validateUpdateAnalysisForm() ? (
            <p className="mt-4 text-center" style={{ color: "red" }}>
              Rellene todos los campos para poder enviar los datos, si hay
              valores que desconoce indique 0
            </p>
          ) : (
            ""
          )}
        </Modal.Body>

        <Modal.Footer className="bg-card-custom">
          <Button
            className="w-100 btn-primary-custom"
            onClick={async () => {
              await handleUpdateAnalysis(
                currentAnalysis.crop_id,
                currentAnalysis
              );
              setShowAnalysisModal(false);
            }}
            disabled={!validateUpdateAnalysisForm()}
          >
            Guardar
          </Button>
          <Button
            className="w-100 btn-danger-custom"
            onClick={() => setShowAnalysisModal(false)}
          >
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal para ver recomendación de riego*/}
      <Modal
        show={showRecommendationModal}
        size="lg"
        onHide={() => setShowRecommendationModal(false)}
      >
        <Modal.Header
          closeButton
          className="bg-card-custom text-center d-flex justify-content-between align-items-center"
        >
          <div>
            <Modal.Title>Recomendación de fertirrigación</Modal.Title>
          </div>
        </Modal.Header>

        <Modal.Body className="bg-card-custom-image">
          <div>
            <b className="mt-2 text-center">Periodo: {period}</b>
            <small className="text-center mt-2 d-block">
              Recomendación de fertirrigación estimada en base a la analítica de
              agua aportada y las necesidades estándar del cultivo.
            </small>
          </div>
          <hr></hr>
          {recommendationsData ? (
            period != 0 ? 
            Object.entries(recommendationsData.fertilizers).map(
              ([key, value]) => {
                return (
                  <div key={key} className="text-center">
                    <h3>{value.name}</h3>
                    <p>{value.formulation}</p>
                    <h3>
                      {value.recommendation >= 0
                        ? value.recommendation.toFixed(2)
                        : 0.0}
                    </h3>
                    (gr/árbol/semana)
                    <hr></hr>
                  </div>
                );
              }
            )
            : <p><b>No hay recomendaciones para el periodo seleccionado</b><hr></hr></p>

          ) : (
            <p>Calculando recomendación...</p>
          )}
          <div>
            <small>
              <b>Recomendación de Zn en aguacate:</b> Aplicación de 300 gr de
              sulfato de zinc al 22% durante el mes de junio. Aportación de
              forma manual repartiendo los 300 gr entre los goteros centrales.
              <br />
              <b>Recomendación de Zn en mango:</b> 3 aplicaciones a
              principios/mediados/finales de junio de 60 litros de sulfato de
              zinc al 35%.
            </small>
          </div>
        </Modal.Body>

        <Modal.Footer className="bg-card-custom">
          <Button
            className="w-100 btn-danger-custom"
            onClick={() => setShowRecommendationModal(false)}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal para ver recomendación de riego*/}
      <Modal
        show={showInfoModal}
        size="lg"
        onHide={() => setShowInfoModal(false)}
      >
        <Modal.Header closeButton className="bg-card-custom">
          <Modal.Title>Información </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-card-custom-image">
          <p>
            GO Axarquía Sostenible es un proyecto innovador que apuesta por la
            regeneración de aguas residuales y la implementación de sistemas de
            fertirriego de precisión en la región de la Axarquía, en respuesta a
            la escasez de agua y a la necesidad de optimizar el uso de recursos
            en la agricultura local.
            <br></br>
            <br></br>
            Entre sus objetivos destacan la optimización del consumo energético
            en el tratamiento y regeneración de aguas, el desarrollo de sistemas
            automatizados para la aplicación controlada de nutrientes, la
            creación de una herramienta de gestión del fertirriego para adaptar
            el riego a las necesidades específicas de cada cultivo, la
            diversificación de los cultivos probados y la demostración de la
            viabilidad económica de la tecnología, así como la formación de
            agricultores y administraciones en estas nuevas técnicas.
            <br></br>
            <br></br>
            Para ello, participa un consorcio compuesto por BIOAZUL
            (coordinadora del proyecto), TROPS (cooperativa líder en la
            producción de mango y aguacate), CSIC-IHSM La Mayora y la Comunidad
            de Regantes de Algarrobo.
          </p>
        </Modal.Body>
        <Modal.Footer className="bg-card-custom">
          <Button
            className="w-100 btn-danger-custom"
            onClick={() => setShowInfoModal(false)}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showUserModal}
        size="lg"
        onHide={() => setShowUserModal(false)}
      >
        <Modal.Header closeButton className="bg-card-custom">
          <Modal.Title>Usuario </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-card-custom-image">
          {" "}
          {/* <p>maria@maria</p> */}
        </Modal.Body>
        <Modal.Footer className="bg-card-custom">
          <Button
            className="w-100 btn-danger-custom"
            onClick={() => setShowUserModal(false)}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showHelpModal}
        size="lg"
        onHide={() => setShowHelpModal(false)}
      >
        <Modal.Header closeButton className="bg-card-custom">
          <Modal.Title>Ayuda </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-card-custom-image">
          {" "}
          Contacte con nosotros mediante este email si desea consultar alguna duda o comunicar alguna
          incidencia.
          <p className="text-center"><b>departamento.idi@trops.es</b></p>
        </Modal.Body>
        <Modal.Footer className="bg-card-custom">
          <Button
            className="w-100 btn-danger-custom"
            onClick={() => setShowHelpModal(false)}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="info-custom text-center">
        <Container className="py-3">
          <Row>
            <Col className="py-2">
              <img
                src="/images/ue.png"
                alt="Logo"
                style={{ width: "190px " }}
              />
              <img src="/images/ja.png" alt="Logo" style={{ width: "90px" }} />
              <img src="/images/zr.png" alt="Logo" style={{ width: "105px" }} />
              <img
                src="/images/TROPS.png"
                alt="Logo"
                style={{ width: "90px" }}
                className="mx-2"
              />
            </Col>
            <small>
              El Grupo Operativo Axarquía Sostenible está subvencionado mediante
              el Fondo Europeo de Agrícola de Desarrollo Rural (FEADER), por la
              Junta de Andalucía a través de la Consejería de Agricultura,
              Ganadería, Pesca y Desarrollo Sostenible, de acuerdo con el
              artículo 18.4 la Ley 38/2003, de 17 de noviembre.
            </small>
          </Row>
        </Container>
      </div>
      <footer className="footer-custom text-center py-2">
        <Container>
          <small>
            Code with ❤️ by{" "}
            <strong>
              <b>
                <a
                  href="https://agualytics.com"
                  className="text-decoration-none text-light"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Agualytics
                </a>
              </b>
            </strong>
          </small>
        </Container>
      </footer>
    </div>
  );
}
export default Crops;
